import { Autocomplete, AutocompleteRenderInputParams, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react'
import Required from '../../../../../utility/required';
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import workflowStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss"
import { customVariableDataInterface } from '../../../../../../models/axiosModel';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import { CombinedUpdateType, combinedValueType } from './variableAssignmentPopup';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { filterAutocompleteOptionsWithException } from '../../../../../../utils/constants';


export interface RenderSourceVariableProps {
    getVariableOptions: () => customVariableDataInterface[]
    chatbot_custom_variable_configuration_id: string,
    checkIfOptionsisDisabled: (chatbot_custom_variable_configuration_id: string, configuration_id: string) => boolean,
    getValueOfFields: (type: combinedValueType) => any,
    onChangeOfFields: ({ type, value }: CombinedUpdateType) => void,
    renderOptions: (props: React.HTMLAttributes<HTMLLIElement>, option: any) => React.ReactNode,
    renderInputForVariableAutoComplete: (params: AutocompleteRenderInputParams, placeholder: string) => JSX.Element,
} 

const RenderSourceVariable: React.FC<RenderSourceVariableProps> = (props) => {
    
    const {getVariableOptions,chatbot_custom_variable_configuration_id , getValueOfFields, onChangeOfFields, renderOptions, renderInputForVariableAutoComplete, checkIfOptionsisDisabled } = props;

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    return (
        <>
            <Grid item xs={12}>
                <Grid container gap={1}>
                    <Grid item xs={12}>
                        <Typography className={styles.createWorkflowLabelStyle}>Source Variable <Required /></Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            className={`${workflowStyles.resetVariableAutoComplete} ${globalStyles.fullwidth}`}
                            options={getVariableOptions()}
                            getOptionLabel={(option) => option?.chatbot_custom_variable_name || ""}
                            filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "chatbot_custom_variable_name", "chatbot_custom_variable_configuration_id")}
                            getOptionDisabled={(option) => checkIfOptionsisDisabled(option?.chatbot_custom_variable_configuration_id, chatbot_custom_variable_configuration_id)}
                            value={getValueOfFields("source variable") as customVariableDataInterface | null}
                            onChange={(_: React.SyntheticEvent, value: customVariableDataInterface | null) => onChangeOfFields({ type: "source variable", value: value })}
                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                            ListboxProps={{ className: contactStyles.listBoxCustomStyle }}
                            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: customVariableDataInterface) => { return renderOptions(props, option); }}
                            renderInput={params => renderInputForVariableAutoComplete(params, 'Select Source Variable')}
                        />
                    </Grid>
                </Grid>
            </Grid> 
        </>
    )
}

export default RenderSourceVariable
